import isPlainObject from './isPlainObject';

/**
 * Deep‑merge **source** into **defaults**, while keeping every key that exists in **defaults**.
 *
 * Rules
 * -----
 * 1. **Both** operands plain objects → recurse per key.
 * 2. Otherwise (arrays, primitives, or mismatched types):
 *    * return **defaults** when `source` is `null` or `undefined`;
 *    * return **source** for any other value.
 */
const mergeWithDefaults = (defaults, source) => {
  // Only deep‑merge when BOTH values are plain objects
  if (isPlainObject(defaults) && isPlainObject(source)) {
    const result = { ...defaults };
    Object.keys(source).forEach((k) => {
      result[k] = mergeWithDefaults(defaults[k], source[k]);
    });
    return result;
  }

  // Primitives, arrays, or mixed types
  return source == null ? defaults : source;
};

export default mergeWithDefaults;
